@if (!item().hidden) {

  <ng-container *aclFeatures="item().section">

    @if (item().url && !item().external) {
      <li [ngClass]="item().classes!"
          [routerLinkActive]="['active']"
          matTooltip="{{ !isEnabled ? 'Logout and Login with Admin to view this page ' : '' }}">
        <a class="nav-link"
           [target]="item().target ? '_blank' : '_self'"
           [ngClass]="{ disabled: !isEnabled }"
           [routerLink]="[item().url]"
           (click)="toggleMenu($event)"
           [routerLinkActive]="['active']">
          @if (!isEnabled) {
            <span class="coded-micon">
              <svg class="pc-icon">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-lock"></use>
              </svg>
            </span>
          } @else {
            @if (item().icon) {
              @if (item().icontype === 'fa') {
                <i class="fa-micon {{item().icon}}"></i>
              } @else{
                <span class="coded-micon">
                  <svg class="pc-icon">
                    <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item().icon }}"></use>
                  </svg>
                </span>
              }
            }
          }
          @if (item().icon) {
            <span class="coded-mtext">{{ item().title | translate }} </span>
          } @else {
            @if (!isEnabled) {
              @if (item().icontype === 'fa') {
                <i class="fa-micon {{item().icon}}"></i>
              } @else{
                <span class="coded-micon">
                  <svg class="pc-icon">
                    <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item().icon }}"></use>
                  </svg>
                </span>
              }
            }
            {{ item().title | translate }}
          }
        </a>
      </li>
    } @else if (item().url && item().external) {
      <li [ngClass]="item().classes!"
          matTooltip="{{ !isEnabled ? 'Logout and Login with Admin to view this page ' : '' }}">
        <a [target]="item().target ? '_blank' : '_self'"
           [href]="item().url"
           [ngClass]="{ disabled: !isEnabled }">
          @if (item().icon) {
            @if (item().icontype === 'fa') {
              <i class="fa-micon {{item().icon}}"></i>
            } @else{
              <span class="coded-micon">
                <svg class="pc-icon">
                  <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item().icon }}"></use>
                </svg>
              </span>
            }
          }
          @if (item().icon) {
            <span class="coded-mtext">{{ item().title | translate }}</span>
          } @else {
            {{ item().title | translate }}
          }
        </a>
      </li>
    }
  </ng-container>
}